import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { Footer } from "../../layouts/footer";
import config from "../../../config";
import { Eye , PencilLine, Trash } from "lucide-react";


const ManageUsers = () => {
  const [users, setUsers] = useState([]); // State to hold categories

  useEffect(() => {

    const fetchUsers = async () => {
      try {
        const response = await fetch(`${config.baseURL}/userdata`); // Update with your backend URL
        const data = await response.json();

        if (Array.isArray(data)) {
          setUsers(data); // Only set if data is an array
        } else {
          console.error("Unexpected response format:", data);
          setUsers([]); // Reset to an empty array if response is invalid
        }
      } catch (error) {
        console.error("Error fetching user:", error);
        setUsers([]); // Reset to an empty array in case of an error
      }
    };

    fetchUsers();
  }, []);

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this User?"
    );
    if (!confirmDelete) return;

    try {
      const response = await fetch(`${config.baseURL}/deleteUser/${id}`, {
        method: "DELETE",
      });

      const data = await response.json();
      if (data.status) {
        alert("User deleted successfully");
        setUsers(users.filter((user) => user.id !== id)); // Update state
      } else {
        alert(data.message || "Failed to delete User");
      }
    } catch (error) {
      console.error("Error deleting category:", error);
      alert("An error occurred while deleting the User");
    }
  };

  return (
    <div className="flex flex-col gap-y-4">
      <h1 className="title">Users</h1>
      <div className="card">
        <div className="card-header flex justify-between">
          <p className="card-title">Registered users</p>
        </div>
        <div className="card-body p-0">
          <div className="relative h-[500px] w-full flex-shrink-0 overflow-auto rounded-none [scrollbar-width:_thin]">
            <table className="table">
              <thead className="table-header">
                <tr className="table-row">
                  <th className="table-head">Id</th>
                  <th className="table-head">fname</th>
                  <th className="table-head">email</th>
                  <th className="table-head">phone</th>
                  <th className="table-head">Actions</th>
                </tr>
              </thead>
              <tbody className="table-body">
                {users.length > 0 ? (
                  users.map((user, index) => (
                    <tr key={user.id} className="table-row">
                      <td className="table-cell">{index+1}</td>
                      <td className="table-cell">{user.fname}</td>
                      <td className="table-cell">{user.email}</td>
                      <td className="table-cell">{user.phone}</td>
                      <td className="table-cell">
                        <div className="flex items-center gap-x-4">
                          <NavLink
                            to={`/admin/viewuser/${user.id}`}
                            className="text-green-500 dark:text-green-600"
                          >
                            <Eye size={20} />
                          </NavLink>
                          <button
                            className="text-red-500"
                            onClick={() => handleDelete(user.id)}
                          >
                            <Trash size={20} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center">
                      No users found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ManageUsers;
